export default "__VITE_ASSET__B06WDpm1__"